import { jsx as _jsx } from "react/jsx-runtime";
import { useRouteParams } from '../../Hooks/UseRouteParams';
import { CoreRoutes } from '../../Coordinator/Coordinator/CoreRoutes';
import { PopUpView } from '../../Components/PopUps/PopUpView';
export function PopUpScreenView(props) {
    const [params] = useRouteParams(CoreRoutes.popUp);
    return _jsx(PopUpView, Object.assign({ visible: true }, params));
}
